const InfoLight = () => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
      <path d="m8 0c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 15.385c-4.072 0-7.385-3.313-7.385-7.385s3.313-7.385 7.385-7.385 7.385 3.313 7.385 7.385-3.313 7.385-7.385 7.385z" />
      <path d="m8 11.385a.307.307 0 0 0 -.308.307v.616a.307.307 0 1 0 .616 0v-.616a.307.307 0 0 0 -.308-.307zm.035-8.615h-.036c-.65 0-1.263.25-1.727.708a2.444 2.444 0 0 0 -.734 1.753.307.307 0 1 0 .616 0c0-.498.195-.965.55-1.315.354-.35.827-.543 1.322-.531.973.013 1.806.847 1.82 1.82a1.838 1.838 0 0 1 -.847 1.578c-.818.528-1.307 1.461-1.307 2.496v.875a.307.307 0 1 0 .616 0v-.875c0-.813.392-1.57 1.025-1.979a2.45 2.45 0 0 0 1.128-2.104 2.478 2.478 0 0 0 -2.426-2.426z" />
    </g>
  </svg>
)

export default InfoLight
